import "./styles/AdminCatalog.css"
import adminCatalogColumns from "./adminCatalogColumns"
import React, { FC, useEffect, useRef, useState } from "react"
import { RootState } from "../../../../store"
import { connect } from "react-redux"
import {
  AdminCatalogTableColumnType,
  CatalogProps,
  AdminCatalogSelectedActionParams,
  Release,
  SortParams,
  TableColumn
} from "../../../../types"
import {
  fetchCatalogData,
  selectCatalogFilter,
  updateReleaseLabelCamp,
  updateReleaseStatus,
  updateReleaseEditStatus,
  deleteRelease
} from "../../../../actions/catalogActions"
import {
  ADMIN_PERMISSIONS,
  adminCatalogTableColumns,
  errorFilledToastOptions,
  infoFilledToastOptions,
  NEW_RELEASE_TYPES,
  RELEASE_FILTER,
  releaseStatusOptions,
  successFilledToastOptions,
  USER_ROLE
} from "../../../../constants"
import { toast } from "react-toastify"
import { KButton, KDropdown, KInput, KSelectRange, KSpan, KTitleSpan, KTooltip } from "kahuna-base-react-components"
import ForceUploadModal from "./modals/ForceUploadModal"
import TableNew from "../../../ui/table/TableNew"
//@ts-ignore
import SparkleIcon from "../../../../assets/admin_icons/music-note-sparkle.svg"
//@ts-ignore
import PlusIcon from "../../../../assets/release-registry-icons/plus.svg"
//@ts-ignore
import EyeIcon from "../../../../assets/admin_icons/eye.svg"
import { useNavigate, useSearchParams } from "react-router-dom"
import CustomizeModal from "./modals/CustomizeModal"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { checkAdminPermission, formatIsoDate, getDaysInMonth, hashids } from "../../../../utility"
import { DateRangeType } from "kahuna-base-react-components/dist/components/KSelectRange/KSelectRange"
import FilterOptionsDialog from "../../catalog/FilterOptionsDialog"
import { isEqual } from "lodash"
import ConfirmationModal from "./modals/ConfirmationModal"
import { releases, users } from "../../../../apis"
import SpotifyArtistModal from "./modals/SpotifyArtistModal"

const AdminCatalog: FC<CatalogProps> = (props) => {
  const [timeoutId, setTimeoutId] = useState(undefined)
  const [loading, setLoading] = useState(true)
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [selectedReleaseToUpload, setSelectedReleaseToUpload] = useState<Release | undefined>(undefined)
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const [hoveredRowId, setHoveredRowId] = useState<number | undefined>(undefined)
  const [openCustomizeModal, setOpenCustomizeModal] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>("")
  const searchOptions: KSelectOption[] = [
    { label: "Release", value: 0, value2: "title" },
    { label: "Artist", value: 1, value2: "artist" },
    { label: "UPC", value: 2, value2: "upc" },
    { label: "Label", value: 3, value2: "label" },
    { label: "ISRC", value: 4, value2: "isrc" },
    { label: "Feat Artist", value: 5, value2: "featuring" }
  ]
  const [selectedSearchOption, setSelectedSearchOption] = useState<KSelectOption>(searchOptions[0])
  const [urlParams, setUrlParams] = useSearchParams()

  const [dateValues, setDateValues] = useState<DateRangeType>([null, null])
  const [dateFilters, setDateFilters] = useState<{ startDate: string | undefined; endDate: string | undefined }>({
    startDate: undefined,
    endDate: undefined
  })
  const [isUserEditSelected, setIsUserEditSelected] = useState<boolean>(false)
  const [openOtherFilters, setOpenOtherFilters] = useState<boolean>(false)
  const [spotifyArtistModalReleaseId, setSpotifyArtistModalReleaseId] = useState<number>()

  const { selectCatalogFilter, selectedCatalogFilter } = props

  const searchParams = new URLSearchParams(location.search)

  const navigate = useNavigate()

  const filtersRef = useRef({
    filter: selectedCatalogFilter,
    search: searchValue,
    date: dateFilters
  })

  const albumLinkLoadingRef = useRef(false)

  const [sortParams, setSortParams] = useState<SortParams>(new SortParams())

  const [selectedActionParams, setSelectedActionParams] = useState<AdminCatalogSelectedActionParams>({
    type: undefined,
    id: undefined,
    status: undefined,
    editStatus: undefined,
    title: undefined,
    checked: false
  })

  useEffect(() => {
    const paramList = ["upc", "title", "artist", "label", "isrc", "featuring"]
    paramList.forEach((param) => {
      if (searchParams && searchParams.get(param) && !searchValue) {
        const searchOption = searchOptions.find((option) => option.value2 === param)
        if (searchOption) {
          setSelectedSearchOption(searchOption)
          setSearchValue(searchParams.get(param) || "")
        }
      }
    })
  }, [searchParams])

  const handleConfirm = () => {
    if (!(selectedActionParams.title && selectedActionParams.id)) return
    if (selectedActionParams.type === "labelCampUpdate") {
      onClickLabelCampCheckbox(selectedActionParams.id, selectedActionParams.checked, selectedActionParams.title)
    } else if (selectedActionParams.type === "statusUpdate") {
      onSelectStatus(selectedActionParams.id, selectedActionParams.status || "", selectedActionParams.title)
    } else if (selectedActionParams.type === "editStatusUpdate") {
      onSelectEditStatus(selectedActionParams.id, selectedActionParams.editStatus || "", selectedActionParams.title)
    } else if (selectedActionParams.type === "releaseDelete") {
      onDelete(selectedActionParams.id, selectedActionParams.title)
    }
    setSelectedActionParams({
      type: undefined,
      id: undefined,
      status: undefined,
      editStatus: undefined,
      title: undefined,
      checked: false
    })
    setHoveredRowId(undefined)
  }

  const handleDescription = () => {
    if (!(selectedActionParams.title && selectedActionParams.id)) return
    if (selectedActionParams.type === "labelCampUpdate") {
      return `Are you sure you want "${selectedActionParams.title}" to be ${
        selectedActionParams.checked ? "VISIBLE" : "NOT VISIBLE"
      } to users?`
    } else if (selectedActionParams.type === "statusUpdate") {
      return `Are you sure you want to change status to ${String(selectedActionParams.status).toUpperCase()} for "${
        selectedActionParams.title
      }" ? `
    } else if (selectedActionParams.type === "editStatusUpdate") {
      return `Are you sure you want to change edit status to ${String(
        selectedActionParams.editStatus
      ).toUpperCase()} for "${selectedActionParams.title}" ? `
    } else if (selectedActionParams.type === "releaseDelete") {
      return `Are you sure you want to delete "${selectedActionParams.title}" ? `
    }
  }

  const onClickLabelCampCheckbox = (id: number, checked: boolean, title: string) => {
    props.updateReleaseLabelCamp(id, checked).then((resp) => {
      if (resp) {
        toast.success("Successfully updated the label camp status.", successFilledToastOptions)
      }
    })
  }

  const onSelectStatus = (id: number, status: string, title: string) => {
    props.updateReleaseStatus(id, status).then((resp) => {
      if (resp) {
        toast.success("Successfully updated the status.", successFilledToastOptions)
      }
      setHoveredRowId(undefined)
    })
  }

  const onSelectEditStatus = (id: number, editStatus: string, title: string) => {
    props.updateReleaseEditStatus(id, editStatus).then((resp) => {
      if (resp) {
        toast.success("Successfully updated the status.", successFilledToastOptions)
      }
      setHoveredRowId(undefined)
    })
  }

  const onDelete = (id: number, title: string) => {
    props.deleteRelease(id).then((resp) => {
      if (resp) {
        toast.success("Successfully Deleted Release.", successFilledToastOptions)
      }
    })
  }

  const onSubmitLabelcamp = (release: Release) => {
    setSelectedReleaseToUpload({ ...release, forceUploadType: NEW_RELEASE_TYPES.LABEL_CAMP })
  }

  const onSubmitBmv = (release: Release) => {
    setSelectedReleaseToUpload({ ...release, forceUploadType: "bmv" })
  }

  const onSubmitMesamMsg = (release: Release) => {
    setSelectedReleaseToUpload({ ...release, forceUploadType: "mesam_msg" })
  }

  const onSubmitEditorialPitching = (release: Release) => {
    setSelectedReleaseToUpload({ ...release, forceUploadType: "editorial_pitching" })
  }

  const onSubmitState51 = (release: Release) => {
    setSelectedReleaseToUpload({ ...release, forceUploadType: "state_51" })
  }

  const onSubmitMarketing = (release: Release) => {
    setSelectedReleaseToUpload({ ...release, forceUploadType: "marketing" })
  }

  const onClickCIColumn = (upc: string) => {
    if (albumLinkLoadingRef.current) return
    albumLinkLoadingRef.current = true
    users(`/get_ci_album_link/?upc=${upc}`, "GET")
      .then((resp) => {
        if (resp && resp?.data && resp?.data?.result) {
          const albumLink = resp.data.result
          window.open(albumLink, "_blank")
        } else {
          toast.error(resp?.data?.message, errorFilledToastOptions)
        }
        albumLinkLoadingRef.current = false
      })
      .catch(() => {
        toast.error("Error getting the Consolidated Independent link", errorFilledToastOptions)
        albumLinkLoadingRef.current = false
      })
  }

  const onClickSpotifyColumn = (upc: string) => {
    if (albumLinkLoadingRef.current) return
    albumLinkLoadingRef.current = true
    users(`/get_spotify_album_link/?upc=${upc}`, "GET")
      .then((resp) => {
        if (resp && resp?.data && resp?.data?.result) {
          const albumLink = resp.data.result
          window.open(albumLink, "_blank")
        } else {
          toast.error("Spotify link for this album could not be found.", errorFilledToastOptions)
        }
        albumLinkLoadingRef.current = false
      })
      .catch(() => {
        toast.error("Error getting the Spotify link", errorFilledToastOptions)
        albumLinkLoadingRef.current = false
      })
  }

  const onClickAppleMusicColumn = (upc: string) => {
    if (albumLinkLoadingRef.current) return
    albumLinkLoadingRef.current = true
    users(`/get_apple_music_album_link/?upc=${upc}`, "GET")
      .then((resp) => {
        if (resp && resp?.data && resp?.data?.result) {
          const albumLink = resp.data.result
          window.open(albumLink, "_blank")
        } else {
          toast.error("Apple Music link for this album could not be found.", errorFilledToastOptions)
        }
        albumLinkLoadingRef.current = false
      })
      .catch(() => {
        toast.error("Error getting the Apple music link", errorFilledToastOptions)
        albumLinkLoadingRef.current = false
      })
  }

  const onReloadLabelCamp = async (title: string, productId: string, skipConfirmation: boolean) => {
    if (!productId) return

    if (!skipConfirmation) {
      if (!window.confirm(`Are you sure? ${title} will be pulled from Labelcamp right away.`)) return
    }

    setLoading(true)
    await releases(`/release/label_camp_product_reload/?product_id=${productId}`, "put")
      .then((resp) => {
        setLoading(false)
        if (resp.data.success) {
          if (!skipConfirmation) {
            toast.success("Reload successfull. Refresh the page to see result", successFilledToastOptions)
          }
        } else {
          toast.error(`Error: ${title}`, { ...errorFilledToastOptions, autoClose: 100000 })
        }
      })
      .catch(() => {
        setLoading(false)
        toast.error(`Error: ${title}`, { ...errorFilledToastOptions, autoClose: 100000 })
      })
  }

  const onCopyUpc = async () => {
    setLoading(true)
    fetchCatalog(0, "upc")
      .then((resp) => {
        if (resp.data.results) {
          const upcCodes = resp.data.results.join(",")
          navigator.clipboard.writeText(upcCodes)
          setLoading(false)
          toast.success("UPC codes copied to clipboard", successFilledToastOptions)
        } else {
          setLoading(false)
          toast.error("Error on bulk reload upload", errorFilledToastOptions)
        }
      })
      .catch(() => setLoading(false))
  }

  const onBulkReloadLabelCamp = async () => {
    if (
      !window.confirm(`${props.paginatedReleases.count} Release found. Are you sure you want to reload from LabelCamp?`)
    ) {
      return
    }

    setLoading(true)
    fetchCatalog(0, "product_id")
      .then(async (resp) => {
        if (resp.data.results) {
          toast.success(`Started processing ${resp.data.count} releases`, successFilledToastOptions)

          let processed = 0
          for (const productId of resp.data.results) {
            processed++
            if (processed % 5 === 0) {
              toast.info(`Processed: ${processed} / ${resp.data.count}`, infoFilledToastOptions)
            }
            await onReloadLabelCamp("", productId, true) // WAIT here!
          }
          setLoading(false)
        } else {
          setLoading(false)
          toast.error("Error on bulk reload upload", errorFilledToastOptions)
        }
      })
      .catch(() => setLoading(false))
  }

  const allColumns = adminCatalogColumns(
    onSubmitLabelcamp,
    onSubmitBmv,
    onSubmitMesamMsg,
    onSubmitEditorialPitching,
    onSubmitState51,
    onSubmitMarketing,
    setSelectedActionParams,
    onReloadLabelCamp,
    onClickSpotifyColumn,
    onClickAppleMusicColumn,
    onClickCIColumn,
    setSpotifyArtistModalReleaseId,
    props.loggedInUser?.adminPermissions
  )

  const [columns, setColumns] = useState<TableColumn[]>(allColumns)

  const [columnsState, setColumnsState] = useState<AdminCatalogTableColumnType[]>(() => {
    const tableColumnsStored = localStorage.getItem("adminCatalogTableColumns")
    if (!tableColumnsStored) return adminCatalogTableColumns
    try {
      const parsedStored = JSON.parse(String(tableColumnsStored))
      if (Array.isArray(parsedStored) && parsedStored.length === adminCatalogTableColumns.length) {
        return parsedStored
      }
    } catch (err) {
      console.error("Invalid JSON in localStorage for adminCatalogTableColumns:", err)
    }
    return adminCatalogTableColumns
  })

  const updateColumns = () => {
    const updatedTableColumns: TableColumn[] = []

    columnsState.forEach((column) => {
      const matching = allColumns.find(
        (tableColumn: TableColumn) => column.name === tableColumn.header && column.visible
      )
      if (matching) {
        updatedTableColumns.push(matching)
      }
    })
    const deleteColumn = allColumns.find((column: TableColumn) => column.header === "")
    if (deleteColumn) {
      updatedTableColumns.push(deleteColumn)
    }
    setColumns(updatedTableColumns)
    setOpenCustomizeModal(false)
  }

  const limit = 10

  useEffect(() => {
    updateColumns()

    const timer = setTimeout(() => {
      selectCatalogFilter(
        checkAdminPermission(ADMIN_PERMISSIONS.USER_ASSET_WRITE, props.loggedInUser?.adminPermissions)
          ? []
          : ["active"],
        RELEASE_FILTER.ALL,
        []
      )
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  const fetchCatalog = async (pageNumber: number, fetchField?: string) => {
    return await props.fetchCatalogData(
      limit,
      (pageNumber - 1) * limit,
      0,
      selectedCatalogFilter,
      selectedSearchOption?.value2 === "title" ? searchValue : undefined,
      selectedSearchOption?.value2 === "upc" ? searchValue : undefined,
      selectedSearchOption?.value2 === "artist" ? searchValue : undefined,
      selectedSearchOption?.value2 === "label" ? searchValue : undefined,
      selectedSearchOption?.value2 === "isrc" ? searchValue : undefined,
      dateFilters.startDate,
      dateFilters.endDate,
      sortParams.field,
      sortParams.direction,
      fetchField,
      selectedSearchOption?.value2 === "featuring" ? searchValue : undefined,
      isUserEditSelected
    )
  }

  const checkReloadVisible = () => {
    const { choosenGenre, choosenStatus } = selectedCatalogFilter
    const { startDate } = dateFilters

    return choosenGenre.length > 0 || choosenStatus.length > 0 || searchValue || startDate
  }

  const onClickPage = async (pageNumber: number) => {
    setLoading(true)
    await fetchCatalog(pageNumber, undefined)
    setLoading(false)
    setPageNumber(pageNumber)
  }

  useEffect(() => {
    const fetchSync = async () => {
      setLoading(true)
      setPageNumber(1)
      await fetchCatalog(1, undefined)
    }
    fetchSync().then(() => setLoading(false))
  }, [selectedCatalogFilter, sortParams.field, sortParams.direction, isUserEditSelected])

  const handleDateChange = () => {
    let start_date: string | undefined = undefined
    let end_date: string | undefined = undefined
    if (dateValues?.[0] && dateValues?.[1]) {
      const startYear = dateValues[0].getFullYear()
      const startMonth = String(dateValues[0].getMonth() + 1).padStart(2, "0")
      start_date = `${startYear}-${startMonth}-01`
      const endYear = dateValues[1].getFullYear()
      const endMonth = String(dateValues[1].getMonth() + 1).padStart(2, "0")
      const end_date_last_day = getDaysInMonth(endYear, dateValues[1].getMonth())
      end_date = `${endYear}-${endMonth}-${end_date_last_day}`
    }
    setDateFilters({ startDate: start_date, endDate: end_date })
  }

  useEffect(() => {
    handleDateChange()
  }, [dateValues])

  const onSearchRelease = (search: string, searchKey: string) => {
    clearTimeout(timeoutId)
    setTimeoutId(
      // @ts-ignore
      setTimeout(async () => {
        setLoading(true)
        setPageNumber(1)
        await props.fetchCatalogData(
          limit,
          0,
          0,
          selectedCatalogFilter,
          searchKey === "title" ? search : undefined,
          searchKey === "upc" ? search : undefined,
          searchKey === "artist" ? search : undefined,
          searchKey === "label" ? search : undefined,
          searchKey === "isrc" ? search : undefined,
          dateFilters.startDate,
          dateFilters.endDate,
          sortParams.field,
          sortParams.direction,
          undefined,
          searchKey === "featuring" ? search : undefined,
          isUserEditSelected
        )
        setLoading(false)

        setUrlParams({ [searchKey]: search })
      }, 800)
    )
  }

  const onDateChange = async () => {
    const currentParams = {
      filter: selectedCatalogFilter,
      search: searchValue,
      date: dateFilters
    }
    if (!isEqual(currentParams, filtersRef.current)) {
      setLoading(true)
      setPageNumber(1)
      await fetchCatalog(1, undefined)
      setLoading(false)
      filtersRef.current = currentParams
    }
  }

  useEffect(() => {
    onDateChange()
  }, [dateFilters.startDate, dateFilters.endDate])

  const renderFilters = () => (
    <div className="flex gap-3">
      <div
        className="flex items-center py-[13px] pl-3.5 pr-3 gap-2 rounded-[10px] w-[370px]"
        style={{
          background: searchValue ? "#FFF" : "#F7F7F7",
          border: "1px solid #F3F3F3",
          height: "48px",
          transition: "0.3s"
        }}
      >
        <KInput
          dataTestId="admin-catalog-search-input"
          value={searchValue}
          padding="0px"
          width={200}
          background="transparent"
          onChange={(text: string) => {
            setSearchValue(text)
            onSearchRelease(text, selectedSearchOption?.value2 || "")
          }}
          leftIcon="/catalog_icons/search-grey.svg"
          gap="8px"
          borderRadius={0}
          shadowDisabled
          placeholder={"Search..."}
        />
        <KDropdown
          dataTestId="admin-catalog-search-dropdown"
          rightIcon="/admin_icons/caret-down.svg"
          selected={selectedSearchOption}
          options={searchOptions}
          onSelect={(selected) => {
            setSelectedSearchOption(selected as KSelectOption)
          }}
          padding="8px"
          background="transparent"
          shadowDisabled={true}
          enableIndicator={true}
          menuWidth={150}
          width={150}
          textColor="#F3F3F3"
        />
      </div>
      <KButton
        dataTestId="admin-catalog-customize-button"
        leftIcon={EyeIcon}
        background="#F7F7F7"
        hoverBackground="#F3F3F3"
        activeBackground="#F7F7F7"
        onClick={() => {
          setOpenCustomizeModal(true)
        }}
        width="auto"
        height="48px"
        padding="14px"
        text="Customize"
        textColor="#000"
        gap="4px"
      />
    </div>
  )

  const tableTitle = (
    <div className="flex flex-row gap-2 items-center !cursor-default">
      <KTooltip
        backgroundColor="#000"
        padding="0px 4px"
        height="20px"
        arrowColor="#000"
        position="bottom"
        content={
          <div className="h-5 w-max flex items-center">
            <KSpan text={openSidebar ? "Hide sidebar" : "Open sidebar"} fontSize={12} lineHeight="16px" color="#FFF" />
          </div>
        }
      >
        <div className="flex items-center">
          <KButton
            dataTestId="sidebar-toggle-button"
            icon="/left-sidebar.svg"
            width="32px"
            height="32px"
            background="transparent"
            shadowDisabled={true}
            padding="6px"
            onClick={() => {
              if (setOpenSidebar) {
                setOpenSidebar(!openSidebar)
              }
            }}
          />
        </div>
      </KTooltip>
      <div className="pt-1">
        {" "}
        <KTitleSpan text="Asset Registry" color="#111" fontSize={20} lineHeight="28px" />
      </div>
    </div>
  )

  const topFilters = (
    <div className="flex justify-between">
      <div className="flex flex-row items-center gap-2">
        <KSelectRange
          key={`${dateFilters.startDate}-${dateFilters.endDate}`}
          value={dateValues}
          onChange={(event) => {
            setDateValues(event)
          }}
          height="36px"
          width="auto"
          backgroundColor="#F7F7F7"
          hoverBackgroundColor="#F3F3F3"
          boxShadow="none"
          align={openSidebar ? "center" : "right"}
        />
        {dateFilters.startDate && dateFilters.endDate && (
          <div className="flex flex-row gap-1 h-9 items-center px-1">
            <KSpan
              text={`${formatIsoDate(dateFilters.startDate, true)} - ${formatIsoDate(dateFilters.endDate, true)}`}
              color="#000"
              fontWeight={500}
            />
            <div
              className="cursor-pointer"
              onClick={() => {
                setDateValues([null, null])
              }}
            >
              <img className="rounded-full hover:bg-[#F3F3F3]" src="/admin_icons/close.svg" />
            </div>
          </div>
        )}
        <KButton
          dataTestId="admin-catalog-filter-button"
          leftIcon="/admin_icons/filters.svg"
          background="#F7F7F7"
          onClick={() => {
            setOpenOtherFilters(true)
          }}
          hoverBackground="#F3F3F3"
          padding="8px"
          height="36px"
          width="auto"
          gap="6px"
          text="Filters"
          shadowDisabled
        />
        <FilterOptionsDialog openFilters={openOtherFilters} setOpenFilters={setOpenOtherFilters} />
      </div>
      {checkReloadVisible() && (
        <div className="flex flex-row items-center gap-4">
          <KButton
            height="36px"
            width="120px"
            text="Copy UPC"
            onClick={() => onCopyUpc()}
            background="black"
            textColor="white"
          />
          <KButton
            height="36px"
            width="220px"
            text="Bulk Reload LabelCamp"
            onClick={() => onBulkReloadLabelCamp()}
            background="black"
            textColor="white"
          />
        </div>
      )}
    </div>
  )

  return (
    <div className="catalog flex bg-[#fff]">
      <div
        className={`${
          openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
        } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0`}
        style={{
          transitionDuration: "0.5s"
        }}
      >
        <div className="pl-6 pr-3 py-4 whitespace-nowrap">
          <KTitleSpan text={"Asset Registry"} lineHeight="28px" fontSize={20} color="#111" />
        </div>

        {[{ label: "Overview", value: "overview", icon: SparkleIcon }, ...releaseStatusOptions].map(
          (option, index: number) => {
            const chosenStatus = selectedCatalogFilter.choosenStatus
            const isSelected =
              option.value === "overview" ? chosenStatus.length === 0 : chosenStatus.includes(option.value)
            return (
              <div data-testid={`status-option-${option.value}`} className="py-1.5 px-4 h-11" key={`${index}`}>
                <div
                  className={`rounded-[10px] p-2 flex flex-row gap-2 ${
                    isSelected ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    let chosenStatus = selectedCatalogFilter.choosenStatus
                    if (option.value === "overview") {
                      chosenStatus = []
                    } else if (option.value !== "overview" && !chosenStatus.includes(option.value.toLowerCase())) {
                      chosenStatus = [...chosenStatus, option.value.toLowerCase()]
                    } else {
                      chosenStatus = chosenStatus.filter((item) => item !== option.value.toLowerCase())
                    }
                    selectCatalogFilter(
                      chosenStatus,
                      selectedCatalogFilter.ownerStatus,
                      selectedCatalogFilter.choosenGenre
                    )
                  }}
                >
                  <img src={option.icon} width={16} height={16} className="shrink-0" />
                  <KSpan text={option.label} fontSize={12} lineHeight="16px" fontWeight={500} color="#111" />
                </div>
              </div>
            )
          }
        )}

        <div data-testid={`user-edit-status-select`} className="py-1.5 px-4 h-11 mt-6">
          <div
            className={`rounded-[10px] p-2 flex flex-row gap-2 ${
              isUserEditSelected ? "bg-[#FFF]" : "transparent"
            } cursor-pointer whitespace-nowrap`}
            onClick={() => setIsUserEditSelected(!isUserEditSelected)}
          >
            <img
              src={props.releaseEditAgainSubmitCount ? "/admin_icons/alert-circle.svg" : "/admin_icons/info-circle.svg"}
              width={16}
              height={16}
              className="shrink-0"
            />
            <KSpan
              text={`Edit Approvals (${props.releaseEditAgainSubmitCount})`}
              fontSize={12}
              lineHeight="16px"
              fontWeight={500}
              color={props.releaseEditAgainSubmitCount ? "red" : "#111"}
            />
          </div>
        </div>
      </div>
      <div className="grow flex justify-center overflow-x-auto">
        <div className="w-full">
          {" "}
          <TableNew
            title={tableTitle}
            pagination
            minRowCount={limit}
            limit={limit}
            columns={columns}
            data={props.paginatedReleases.results}
            count={props.paginatedReleases.count}
            topRightElement={renderFilters()}
            topFilters={topFilters}
            onClickPage={onClickPage}
            rowHeightInPx={40}
            loading={loading}
            overrideTableOverflow="auto"
            {...(checkAdminPermission(ADMIN_PERMISSIONS.ASSET_REGISTRY_WRITE, props.loggedInUser?.adminPermissions) && {
              onSelectRow: (index: number | null, row) => {
                navigate(`${hashids.encode(row?.id?.toString() || "")}`)
              }
            })}
            onMouseEnterRow={(row: any, index: number) => {
              setHoveredRowId(index)
            }}
            onMouseLeaveRow={(row: any, index: number) => {
              if (hoveredRowId === index) {
                setHoveredRowId(undefined)
              }
            }}
            hoveredRowId={hoveredRowId}
            pageNumber={pageNumber}
            sortParamsReader={setSortParams}
            overrideSortParams={true}
            sortParamsValue={sortParams}
            paginationKey={`${sortParams.field}-${sortParams.direction}`}
          />
        </div>
      </div>
      <ForceUploadModal release={selectedReleaseToUpload} setRelease={setSelectedReleaseToUpload} />
      <CustomizeModal
        open={openCustomizeModal}
        setOpen={setOpenCustomizeModal}
        onApprove={updateColumns}
        columnsState={columnsState}
        setColumnsState={setColumnsState}
        sortParams={sortParams}
        setSortParams={setSortParams}
      />
      <SpotifyArtistModal
        spotifyArtistModalReleaseId={spotifyArtistModalReleaseId}
        setSpotifyArtistModalReleaseId={setSpotifyArtistModalReleaseId}
      />
      <ConfirmationModal
        isOpen={selectedActionParams.type !== undefined}
        handleClose={() => {
          setSelectedActionParams({
            type: undefined,
            id: undefined,
            title: undefined,
            status: undefined,
            editStatus: undefined,
            checked: false
          })
        }}
        handleConfirm={handleConfirm}
        description={handleDescription() || ""}
      />
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user,
    loggedInUser: state.auth.user,
    paginatedReleases: state.catalogData.paginatedReleases,
    selectedCatalogFilter: state.catalogData.selectedCatalogFilter,
    releaseEditAgainSubmitCount: state.admin.releaseEditAgainSubmitCount
  }
}

export default connect(mapStateToProps, {
  fetchCatalogData,
  selectCatalogFilter,
  updateReleaseLabelCamp,
  updateReleaseStatus,
  updateReleaseEditStatus,
  deleteRelease
})(AdminCatalog)
